import { ResponsibleType } from '@/ui/modules/admin/views/Responsibles/responsibleType'

import { axios, Response } from '../index'

export interface Patient {
  id: string
  name: string
  avatarName: string
  avatar: string
  active: boolean
  responsible: Responsible[]
  therapistManagers: TherapistManager[]
}

export interface Responsible {
  id: string
  name: string
  avatarName: string
  avatar: string
  responsibleType: ResponsibleType
}

export interface AccessProfile {
  id: string
  name: string
}

export interface TherapistManager {
  id: string
  userId: string
  username: string
  avatarUrl: string
  type: string
  accessProfile: AccessProfile
}

export default async function getClinicPatients(): Response<Patient[]> {
  return await axios.get(`/v1/patients`)
}
